var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessage = function SvgMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    clipPath: "url(#message_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    d: "M16.481 9.89v3.667c0 .239-.009.468-.036.688-.211 2.475-1.669 3.703-4.354 3.703h-.367c-.23 0-.45.11-.587.294l-1.1 1.466c-.486.651-1.274.651-1.76 0l-1.1-1.466a.85.85 0 0 0-.586-.294h-.367c-2.924 0-4.391-.724-4.391-4.39V9.89c0-2.686 1.238-4.143 3.703-4.354.22-.028.45-.037.688-.037h5.867c2.924 0 4.39 1.467 4.39 4.39"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    d: "M20.149 6.224v3.667c0 2.695-1.238 4.143-3.704 4.354.028-.22.037-.45.037-.688V9.891c0-2.924-1.467-4.391-4.39-4.391H6.224q-.358-.002-.688.037c.21-2.466 1.668-3.704 4.354-3.704h5.867c2.924 0 4.39 1.467 4.39 4.391"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.371 12.146h.008M9.162 12.146h.008M5.954 12.146h.008"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "message_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v22H0z"
  })))));
};
export default SvgMessage;